export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["如果您看到此消息，表单未收到（但您不应看到此消息）"])}
}